<div *ngIf="inContainer else mainContent" class="monthly-totals-card">
    <div class="header-container">
        <div class="title-container tw-items-center">
            <div class="tw-font-bold">
                Monthly Totals
            </div>
            <div class="edit" mat-raised-button color="primary" *ngIf="bankValues$ | async">
                <div class="edit-text-container" (click)="showMonthlyTotalsDialogEdit()">
                    <span>Edit</span>
                </div>
            </div>
        </div>
    </div>

  <ng-container [ngTemplateOutlet]="mainContent"></ng-container>

</div>

<ng-template #mainContent>
  <ng-container *ngIf="(bankAccountsOcrolusStatus$ | async) as ocrolusStatus">
    <div class="alternate-transactions-warning">
      <app-alert *ngIf="ocrolusStatus.hasOcrolusErrors && (canAcknowledgeDocErrors$ | async) as canAcknowledge" [level]="'warning'" (dismissed)="onOcrolusErrorDismiss(canAcknowledge)">
        <span>A bank statement has been identified as potential fraud or incomplete. <a class="hover-hand" (click)="goToDocuments()">View docs</a></span>
      </app-alert>
      <app-alert *ngIf="ocrolusStatus.hasOcrolusErrors && !(canAcknowledgeDocErrors$ | async)" [level]="'warning'">
        <span>A bank statement has been identified as potential fraud or incomplete. <a class="hover-hand" (click)="goToDocuments()">View docs</a></span>
      </app-alert>
      <app-alert *ngIf="ocrolusStatus.ocrolusStatus === 'pending'" [message]="'Bank statements are on their way.'" [level]="'info'"></app-alert>
      <app-alert *ngIf="ocrolusStatus.mostRecentSummaryOutdated" [message]="'Most recent bank statement monthly summary is outdated.'" [level]="'warning'"></app-alert>
    </div>
  </ng-container>

  <ng-container *ngIf="((alternateLenderTransactions$ | async)?.length > 0)">
    <div class="alternate-transactions-warning">
      <app-alert *ngIf="alternateLenderTransactions$ | async as alternateTransactions" [level]="'warning'">
        <div>
          This borrower may have current financing.
          <a class="hover-hand" (click)="showAlternateTransactionsDialog(alternateTransactions)">Click here to view details.</a>
        </div>
      </app-alert>
    </div>
  </ng-container>
  <app-monthly-totals-card *ngIf="(bankValues$ | async) as bankValues; else loading" [bankValues]="bankValues" [currencyCode]="localeSetting.getCurrencyCode()" [bankConnection]="(bankConnection$ | async)?.created" [currencySymbol]="localeSetting.getLocaleCurrencySymbol()" [basicStyle]="basicStyle"></app-monthly-totals-card>
  <ng-template #loading>
    <div class="tw-flex tw-justify-center tw-p-6">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  </ng-template>
</ng-template>
